
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 rounded-3xl mx-10 my-10 px-12 py-16 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 text-white/5 text-[180px] font-bold leading-none select-none pointer-events-none">
        LEARN
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-4 gap-12 relative z-10">
        <div className="col-span-1">
          <Link to="/" className="flex items-center gap-3 mb-4">
            <img
              src="https://public.readdy.ai/ai/img_res/5ec6b76e-b89f-44fa-a5db-df42b5e86c33.png"
              alt="KienThucPlus"
              className="h-12 w-12 object-contain"
            />
            <span className="text-xl font-bold text-white">KienThucPlus</span>
          </Link>
          <p className="text-white/80 text-sm leading-relaxed">
            Nền tảng học tập trực tuyến hàng đầu cho học sinh THCS và THPT
          </p>
        </div>

        <div>
          <h4 className="text-white text-lg font-semibold mb-4">Môn Học</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/toan" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                Toán
              </Link>
            </li>
            <li>
              <Link to="/ly" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                Lý
              </Link>
            </li>
            <li>
              <Link to="/hoa" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                Hóa
              </Link>
            </li>
            <li>
              <Link to="/van" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                Văn
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg font-semibold mb-4">Theo Dõi</h4>
          <ul className="space-y-3">
            <li>
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                <i className="ri-facebook-circle-fill text-base w-5 h-5 flex items-center justify-center"></i>
                Facebook
              </a>
            </li>
            <li>
              <a href="https://youtube.com" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                <i className="ri-youtube-fill text-base w-5 h-5 flex items-center justify-center"></i>
                YouTube
              </a>
            </li>
            <li>
              <a href="https://zalo.me" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                <i className="ri-message-3-fill text-base w-5 h-5 flex items-center justify-center"></i>
                Zalo
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg font-semibold mb-4">Nhận Tài Liệu Miễn Phí</h4>
          <div className="relative">
            <input
              type="email"
              placeholder="Email của bạn"
              className="w-full px-4 py-3 bg-transparent border border-white/30 rounded-full text-white placeholder-gray-400 text-sm focus:outline-none focus:border-white/60 transition-colors"
            />
            <button className="absolute right-1 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer">
              <i className="ri-arrow-right-line text-black text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/10 flex items-center justify-between relative z-10">
        <p className="text-gray-400 text-sm">© 2025 KienThucPlus. Bản quyền thuộc về chúng tôi.</p>
        <a 
          href="https://readdy.ai/?ref=logo" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"
        >
          Powered by Readdy
        </a>
      </div>
    </footer>
  );
};

export default Footer;
